import React from "react";
import moment from "moment";
import NotificationTipItem from "./components/NotificationTipItem";
import NotificationRakebackItem from "./components/NotificationRakebackItem";
import NotificationDepositWithdraw from "./components/NotificationDepositWithdraw";
import offers from "../../containers/settings/offers";
import NotificationRainIten from "./components/NotificationRainItem";
import SvgIcon from "../svg-icon";
import NotificationRaffleItem from "./components/NotificationRaffleItem";
import NotificationRaceItem from "./components/NotificationRaceItem";
import NotificationTournamentWin from "./components/NotificationTournamentWin";
import NotificationRankUpdate from "./components/NotificationRankUpdate";
import NotificationsWelcomeBonus from "./components/NotificationsWelcomeBonus";
import NotificationBonusActivated from "./components/NotificationBonusActivated";

const NotificationItem = (props) => {

    const {type, timestamp, lang_key, data} = props.notification
    // todo [ti-circle-check,ti-circle-x,ti-info-circle,ti-info-gift]

    const getIcon = () => {
        switch (type) {
            case 'transaction':
            case 'rakeback':
            case 'tip':
            case 'deposit':
            case 'reload':
                return 'gift';
            // return 'ti ti-gift';
            case 'info':
                // return 'ti ti-circle-info-circle';
                return 'info';

            case 'success':
                return 'checked';


            case 'error':
                return 'error';

            default:
                return 'ti-info-circle';

        }
    }


    if (type === 'tip')
        return <NotificationTipItem {...{type, timestamp, lang_key, data}}/>

    if (type === 'rakeback' || type === 'reload')
        return <NotificationRakebackItem {...{type, timestamp, lang_key, data}}/>

    if (type === 'rain')
        return <NotificationRainIten {...{type, timestamp, lang_key, data}}/>

    if (type === 'withdraw' || type === 'deposit')
        return <NotificationDepositWithdraw {...{type, timestamp, lang_key, data}}/>

    if (type === 'raffle')
        return <NotificationRaffleItem {...{type, timestamp, lang_key, data}}/>

    if (type === 'race')
        return <NotificationRaceItem {...{type, timestamp, lang_key, data}}/>

    if (type === 'tournament')
        return <NotificationTournamentWin {...{type, timestamp, lang_key, data}}/>

    if (type === 'rank-update')
        return <NotificationRankUpdate {...{type, timestamp, lang_key, data}}/>

    if (type === 'welcome-bonus')
        return <NotificationsWelcomeBonus {...{type, timestamp, lang_key, data}}/>


    if (type === 'bonus-activated')
        return <NotificationBonusActivated {...{type, timestamp, lang_key, data}}/>



    return (
        <li>
            <a onClick={null} className="green gap-2">
                {/*<i className={getIcon()}/>*/}
                <SvgIcon id={getIcon()}/>
                <p>{lang_key}</p>
                <span>{moment.unix(timestamp).format('MMM Do YY')}</span>
            </a>
        </li>
    )
}

export default NotificationItem
